import React from "react";

import Box from "components/common/Box";

const WelcomeSlideFooter = ({ slides, activeIndex, onGoToSlide, classes }) => (
  <Box className={classes.footer}>
    <Box className={classes.dots} role="tablist" aria-label="Welcome slides">
      {slides.map((item, index) => {
        const isActive = index === activeIndex;

        return (
          <Box
            key={item.id}
            component="button"
            type="button"
            role="tab"
            aria-selected={isActive}
            aria-label={`Slide ${index + 1} of ${slides.length}`}
            className={`${classes.dot} ${isActive ? classes.dotActive : ""}`}
            onClick={() => onGoToSlide(index)}
          />
        );
      })}
    </Box>
  </Box>
);

export default WelcomeSlideFooter;
